import { SceneConfig } from "../lib/types";

/**
 * ImageShow 功能演示视频
 *
 * 展示 5 种俏皮图片入场效果，配标题文字
 */
export const imageDemoConfig: SceneConfig[] = [
  // ──────────── S01: 🎈 弹跳入场 ────────────
  {
    sceneId: "S01",
    durationInFrames: 75, // ~2.5s @ 30fps
    preset: "ImageShow.bounce",
    props: {
      src: "images/pexels-modern-technology-6913227.jpg",
      title: "科技赋能",
      subtitle: "Bounce — 弹跳入场",
    },
  },

  // ──────────── S02: 🔍 从大缩小入场 ────────────
  {
    sceneId: "S02",
    durationInFrames: 75,
    preset: "ImageShow.zoomIn",
    props: {
      src: "images/pexels-city-night-20716167.jpg",
      title: "城市夜景",
      subtitle: "Zoom In — 从大缩小入场",
    },
  },

  // ──────────── S03: 🌀 旋转弹入 ────────────
  {
    sceneId: "S03",
    durationInFrames: 80,
    preset: "ImageShow.rotateBounce",
    props: {
      src: "images/pexels-nature-landscape-mountain-19961158.jpg",
      title: "山川壮丽",
      subtitle: "Rotate Bounce — 旋转弹入",
    },
  },

  // ──────────── S04: 🍃 飘浮入场 ────────────
  {
    sceneId: "S04",
    durationInFrames: 75,
    preset: "ImageShow.floatIn",
    props: {
      src: "images/pexels-modern-technology-7688549.jpg",
      title: "创新未来",
      subtitle: "Float In — 飘浮入场",
    },
  },

  // ──────────── S05: 🌀 旋转弹入（原 3D 翻牌已移除） ────────────
  {
    sceneId: "S05",
    durationInFrames: 85,
    preset: "ImageShow.rotateBounce",
    props: {
      src: "images/pexels-city-night-32445530.jpg",
      title: "绚丽都市",
      subtitle: "Rotate Bounce — 旋转弹入",
    },
  },
];
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
